import { useContext } from "react";
import { AccountSearchViewHeader } from "./no-result-header";
import { PagesClientSearchResultCountPilll } from "./result-count-pill";
import { AccountSearchContext } from "@dealer-center/ddc-pages-account-search-context";

export const AccountSearchViewHeaders = () => {
  const { accountSearchGet: accountSearchResult } =
    useContext(AccountSearchContext);
  if (accountSearchResult?.data?.totalHits === undefined)
    return <AccountSearchViewHeader />;
  return (
    <PagesClientSearchResultCountPilll
      resultCount={accountSearchResult?.data?.totalHits}
    />
  );
};
